import { render, staticRenderFns } from "./NewSeason.vue?vue&type=template&id=be5a2098&scoped=true&"
import script from "./NewSeason.vue?vue&type=script&lang=js&"
export * from "./NewSeason.vue?vue&type=script&lang=js&"
import style0 from "./NewSeason.vue?vue&type=style&index=0&id=be5a2098&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5a2098",
  null
  
)

export default component.exports